/**
 * @property editMode {boolean} if true will be show edit mode.
 */
import React, { Component } from "react";
import Select from "react-select";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import InputField from "../../framework/InputField/InputField";
import Checkbox from "material-ui/Checkbox";
import Dialog from "material-ui/Dialog";
import "./edit-client-profile.css";
import Clear from "material-ui/svg-icons/content/clear";
import groupBy from "lodash/groupBy";
import CustomSelect from "../../framework/CustomSelect/CustomSelect";
import MaskedInput from "react-text-mask";
import Dropzone from "react-dropzone";
import FlatButton from "material-ui/FlatButton";
import { buttonBlueColor, insightHeaderDataUri } from "../../../utils/utility";
import Error from "material-ui/svg-icons/alert/error";
import moment from "moment";

import imageNotAvailable from "../../MyProfile/image_not_available.png";
import profileWorker from "../../MyProfile/worker";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import concat from "lodash/concat";
import { FullRow } from "../../framework/Grid";
import isEqual from "lodash/isEqual";
var validator = require("email-validator");

const suspendDialogStyle = {
  cancel: {
    height: "30px",
    background: "white",
    color: "black",
    border: "1px solid #B1B0B0",
    fontWeight: "bold",
    marginRight: "10px",
    padding: "0 10px",
    fontSize: "12px",
  },
  suspend: {
    height: "30px",
    background: "#DD0000",
    color: "white",
    border: "none",
    fontWeight: "bold",
    padding: "0 10px",
    fontSize: "12px",
  },
};
const styles = {
  iconStyle: {
    fill: "#000000",
    transform: "scale(0.9)",
    WebkitTransform: "scale(0.9)",
    MsTransform: "scale(0.9)",
    MozTransform: "scale(0.9)",
    marginRight: "16px",
    marginLeft: "-1px",
  },
  labelStyle: {
    fontSize: "16px",
    lineHeight: "15px",
    marginBottom: 0,
    paddingTop: "3px",
    fontWeight: "normal",
  },
};
class BusinessUnitsDetail extends Component {
  constructor(props) {
    super(props);
    this.myProfile_worker = new Worker(profileWorker);
    this.flagBase = true;
    this.throttleEditBusinessUnit = true; // for edit business unit profile
    const months = [
      { value: "01", label: "Jan" },
      { value: "02", label: "Feb" },
      { value: "03", label: "Mar" },
      { value: "04", label: "Apr" },
      { value: "05", label: "May" },
      { value: "06", label: "Jun" },
      { value: "07", label: "Jul" },
      { value: "08", label: "Aug" },
      { value: "09", label: "Sep" },
      { value: "10", label: "Oct" },
      { value: "11", label: "Nov" },
      { value: "12", label: "Dec" },
    ];
    const years = [];
    for (var i = 0; i < 10; i++) {
      years.push({
        value: moment().add(i, "years").format("YYYY"),
        label: moment().add(i, "years").format("YYYY"),
      });
    }
    this.state = {
      expMonth: null,
      expYear: null,
      years: years,
      months: months,
      ori_edit_client_profile: {},
      consumerDataSource: "",
      ifShowSuspend: false,
      ifHiddenTopEdit: true,
      stateValue: "",
      ifHiddenLogoEdit: true, // for logo
      logoFileName: "No file chosen", // for logo
      ifLogoUploadButtonEnable: false, // for logo
      ifLogoSaveBtnEnable: false, // for logo
      logoUploadSuccess: false, // for logo
      industryGroupObj: [],
      companyLogoErrorText: "",
      campaignReportPreference: "Aggregated",
      consumerRecords: 500, // consumer default value
      businessRecords: 200, // business default value
      audienceResolutionGranularity: "Scale",
      status: "",
      industry: {
        id: "",
        name: "",
      },
      subscription: {
        id: "",
        name: "",
      },
      accountManagers: [
        {
          id: "",
          firstName: "",
          lastName: "",
        },
      ],
      imgDataBase64: "", // for logo
      newLogoBase64: "", // for logo
      requestParams: {
        name: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipCode: "",
        phone: "",
        timezone: "",
        email: "",
        industryId: "",
        // subscriptionTierId: '',
        accountManagerUserIds: [""],
        campaignReportPreference: "",
        logoUuid: "",
        contractNumber: "",
        salesForceId: "",
      },
      contractNumberText: "",
      ifShowContractNumber: false,
      showDowngradeConfirm: false,
      segmentationSystem: "prizm_premier",
      appendSegmentation: false,
    };
  }
  componentDidMount() {
    // when administarator
    if (this.props.editMode) {
      this.setState({
        ifHiddenTopEdit: false,
      });
    }
    if (/^(administrator| team member)/gi.test(this.props.roleName)) {
      this.setState({
        ifHiddenTopEdit: false,
      });
    }
    this.props.getClientProfile(this.props.match.params.businessUnitId);
    this.props.getTimezone();
    this.props.getIndustryOptions();
    this.props.getTierOptions();
    if (this.props.match.params.id) {
      this.props.getTeamMember(this.props.match.params.id);
    } else {
      if (/^(administrator| team member)/gi.test(this.props.roleName)) {
        this.props.getTeamMember(this.props.loginUserDetail.client.id);
      }
    }
    this.props.getCompanyLogo(this.props.match.params.businessUnitId);
    this.props.getStates();
    localStorage.setItem("newLogoBase64", "");
    if (
      this.props.edit_client_profile &&
      this.props.edit_client_profile.subscriptionTierId >= 3 &&
      this.props.edit_client_profile.subscriptionTierId != 5
    ) {
      this.props.getConfigInsightsStandard(
        this.props.match.params.businessUnitId,
      );
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      /^Please add a contract number/g.test(
        nextProps.createClientProfileMessage,
      )
    ) {
      this.setState({
        ifShowContractNumber: true,
        contractNumberText: "Please add a contract number",
      });
    }
    // set 3rd part dataSource
    // for edit business unit profile
    if (this.throttleEditBusinessUnit && nextProps.match.params.id) {
      if (
        nextProps.edit_client_profile &&
        nextProps.edit_client_profile.subscriptionTierId >= 3 &&
        nextProps.edit_client_profile.subscriptionTierId != 5
      ) {
        this.props.getConfigInsightsStandard(
          nextProps.match.params.businessUnitId,
        );
        this.throttleEditBusinessUnit = false;
      }
    }
    if (
      isEmpty(this.state.industryGroupObj) &&
      !isEmpty(nextProps.industryOptions)
    ) {
      let industryGroup = groupBy(nextProps.industryOptions, "group");
      let obj = [];
      for (let x in industryGroup) {
        obj.push({
          label: x,
          options: industryGroup[x],
        });
      }
      this.setState({
        industryGroupObj: obj,
      });
    }
    if (
      nextProps.edit_client_profile.name &&
      !isEqual(
        nextProps.edit_client_profile,
        this.state.ori_edit_client_profile,
      )
    ) {
      const {
        name,
        address1,
        address2,
        city,
        state,
        status,
        zipCode,
        phone,
        timezone,
        industryId,
        accountManagerUserIds,
        subscriptionTierId,
        industry,
        subscription,
        accountManagers,
        accountNumber,
        logo,
        campaignReportPreference,
        contractNumber,
        clientReportDetailSetting,
        audienceResolutionGranularity,
        salesForceId,
        email,
      } = nextProps.edit_client_profile;
      // for logo
      if (
        logo !== "logo.png" &&
        typeof logo !== "undefined" &&
        typeof nextProps.company_logo === "object"
      ) {
        // change blob to base64 for img element. and implement one time.
        this.myProfile_worker.postMessage(nextProps.company_logo);
        this.myProfile_worker.onmessage = (e) => {
          this.setState({
            imgDataBase64: e.data,
          });
        };
      } else {
        this.setState({
          imgDataBase64: imageNotAvailable,
        });
      }
      if (nextProps.allstates.length > 0) {
        let stateValue =
          nextProps.allstates.filter((item) => item.value === state).length !==
            0 &&
          nextProps.allstates.filter((item) => item.value === state)[0].label;
        this.setState({
          stateValue,
        });
      }
      if (nextProps.timezone.length > 0) {
        let timezoneValue = nextProps.timezone.filter(
          (item) => item.value === timezone,
        )[0].label;
        this.setState({
          timezoneValue,
        });
      }
      this.setState({
        ori_edit_client_profile: Object.assign(
          {},
          nextProps.edit_client_profile,
        ),
        status, // status can ben suspend or active,
        industry: typeof industry !== "undefined" && industry,
        subscription: typeof subscription !== "undefined" && subscription,
        accountManagers:
          !isEmpty(accountManagers) &&
          accountManagers[0] &&
          accountManagers[0].status !== "Suspended"
            ? accountManagers
            : [{}],
        audienceResolutionGranularity: audienceResolutionGranularity,
        requestParams: {
          ...this.state.requestParams,
          name,
          address1,
          address2,
          city,
          state,
          status,
          zipCode,
          phone,
          timezone,
          industryId,
          campaignReportPreference,
          subscriptionTierId,
          contractNumber,
          email,
          salesForceId,
          accountManagerUserIds: !isEmpty(accountManagers)
            ? map(accountManagers, "id")
            : [""],
          accountNumber,
          clientReportDetailSetting: clientReportDetailSetting,
        },
      });
      // for edit client profile
    }
    if (!isEmpty(this.refs)) {
      const { subscriptionTierId } = this.props.edit_client_profile;
      if (
        ((parseInt(subscriptionTierId, 10) >= 3 &&
          parseInt(subscriptionTierId, 10) !== 5) ||
          parseInt(subscriptionTierId, 10) === 1) &&
        nextProps.insights_standard_config !== "" &&
        (/^\/clients\/edit\/Business-Units\/detail/g.test(
          this.props.location.pathname,
        ) ||
          /^\/clients\/edit\/Client-Profile/g.test(
            this.props.location.pathname,
          ))
      ) {
        const { insights_standard_config } = nextProps;
        // set consumer and business for edit client profile
        this.refs.consumer.value =
          insights_standard_config.maxMonthlyConsumerRecords;
        this.refs.business.value =
          insights_standard_config.maxMonthlyBusinessRecords;
        this.setState({
          consumerDataSource: insights_standard_config.consumerDataSource, //subscriptionTierId === 1 ? this.props.insights_standard_config.consumerDataSource : 'InfoGroup',
          businessDataSource: insights_standard_config.businessDataSource,
          consumerRecords: insights_standard_config.maxMonthlyConsumerRecords,
          businessRecords: insights_standard_config.maxMonthlyBusinessRecords,
          appendSegmentation: insights_standard_config.appendSegmentation,
          licenseNum: insights_standard_config.segmentationLicenseNumber,
          segmentationSystem: insights_standard_config.segmentationSystem,
          expMonth: moment(
            insights_standard_config.licenseExpirationDate,
          ).format("MM"),
          expYear: moment(
            insights_standard_config.licenseExpirationDate,
          ).format("YYYY"),
        });
      } else if (
        ((subscriptionTierId >= 3 && subscriptionTierId !== 5) ||
          subscriptionTierId === 1) &&
        nextProps.insights_standard_config ===
          "" /*&& this.refs.consumer && this.refs.business*/
      ) {
        this.refs.consumer.value = 0;
        this.refs.business.value = 0;
        this.setState({
          consumerRecords: 0,
          businessRecords: 0,
          consumerDataSource:
            window.location.href.indexOf("app.") >= 0 ? "InfoGroup" : "Epsilon",
          businessDataSource: "InfoGroup",
        });
      }
    }
  }
  filterSubscriptionTierId(nextProps, subscriptionTierId) {
    if (
      /^\/clients\/edit\/Business-Units\/detail/g.test(
        nextProps.location.pathname,
      )
    ) {
      if (
        /^(system administrator|account manager)/gi.test(nextProps.roleName)
      ) {
        return "";
      }
    }
    if (/^\/clients\/edit\/Client-Profile/g.test(nextProps.location.pathname)) {
      if (
        /^(system administrator|account manager)/gi.test(nextProps.roleName)
      ) {
        return "";
      }
    }
  }
  handleLogoEdit() {
    this.setState({
      ifHiddenLogoEdit: false,
    });
  }
  handleCancelLogoEdit() {
    this.setState({
      ifHiddenLogoEdit: true,
      newLogoBase64: "",
      logoFileName: "No file chosen",
    });
    localStorage.setItem("newLogoBase64", "");
  }
  handleEdit() {
    if (!this.state.ifHiddenTopEdit) {
      this.props.getClientProfile(this.props.match.params.businessUnitId);
    }
    if (this.props.editMode) {
      this.props.handleCancel();
    }
    this.setState(
      {
        ifHiddenTopEdit: !this.state.ifHiddenTopEdit,
      },
      () => {
        if (this.refs.consumer && this.refs.business) {
          this.refs.consumer.value = this.state.consumerRecords;
          this.refs.business.value = this.state.businessRecords;
        }
      },
    );
  }
  handleDrop(files, accept, reject) {
    this.setState({
      logoFileName: files[0],
      ifLogoUploadButtonEnable: true,
      companyLogoErrorText: "",
    });
  }
  onDropRejected() {
    this.setState({
      companyLogoErrorText:
        "Only jpg, png, and gif file with maximum size of 1MB is allowed",
    });
  }
  handleUploadLogo() {
    if (this.state.ifLogoUploadButtonEnable) {
      let formData = new FormData();
      formData.append("logo", this.state.logoFileName);
      // call api
      fetch(
        `/api/clients/${this.props.match.params.businessUnitId}/logo/upload`,
        {
          method: "POST",
          body: formData,
          headers: new Headers({
            Authorization: this.props.token,
          }),
        },
      )
        .then(
          (res) => {
            if (res.status === 200) {
              return res.json();
            } else {
              res.json().then((json) => {
                this.setState({
                  companyLogoErrorText: json.message,
                });
              });
            }
          },
          () => {},
        )
        .then((json) => {
          if (typeof json !== "undefined") {
            localStorage.setItem(
              "newLogoBase64",
              this.state.logoFileName.preview,
            );
            this.setState({
              companyLogoErrorText: "",
              ifLogoSaveBtnEnable: true,
              logoUploadSuccess: true,
              requestParams: {
                ...this.state.requestParams,
                logoUuid: json.uuid,
              },
              newLogoBase64: this.state.logoFileName.preview,
            });
          }
        })
        .catch((err) => {
          alert(err);
        });
    }
  }
  handleUpdatelogo() {
    if (this.state.ifLogoSaveBtnEnable) {
      this.props.updateLogo(
        this.props.match.params.businessUnitId,
        this.state.requestParams.logoUuid,
      );
    }
  }
  handleCloseDialog() {
    // reload redux
    this.props.setStatus(false);
  }
  handleTimeZoneChange(value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        timezone: value.value,
      },
    });
  }
  handleIndustryChange(value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        industryId: value.value,
      },
    });
  }
  handleReassignTo(value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        accountManagerUserIds: value,
      },
    });
  }
  handleUpdate() {
    let requestData = this.state.requestParams;
    if (this.state.requestParams.subscriptionTierId === 5) {
      this.setState({
        requiredEmailText: "",
      });
      if (this.state.requestParams.email.trim().length === 0) {
        this.setState({
          requiredEmailText: "Please enter email address",
        });
        return;
      } else {
        if (!validator.validate(this.state.requestParams.email.trim())) {
          this.setState({
            requiredEmailText: "Invalid email address",
          });
          return;
        }
      }
    }
    if (
      /^\/clients\/edit\/Business-Units\/detail/g.test(
        this.props.location.pathname,
      )
    ) {
      if (
        /^(system administrator|account manager)/gi.test(this.props.roleName)
      ) {
        // update consumer and business records
        //if (this.state.requestParams.subscriptionTierId >= 3 ) {
        // for edit business unit profile and create business unit profile
        /*
          this.props.configInsightsStandard(this.props.match.params.businessUnitId, {
            // id: parseInt(this.props.match.params.businessUnitId),
            maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
            maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
            consumerDataSource: this.state.consumerDataSource,
            businessDataSource: 'InfoGroup'
          })*/
        const { requestParams } = this.state;

        if (
          requestParams.accountManagerUserIds &&
          requestParams.accountManagerUserIds.length > 0 &&
          requestParams.accountManagerUserIds[0] === ""
        ) {
          requestParams.accountManagerUserIds = undefined;
        } else {
          if (
            requestParams.accountManagerUserIds &&
            requestParams.accountManagerUserIds[0].value
          ) {
            const vals = map(requestParams.accountManagerUserIds, "value");
            requestParams.accountManagerUserIds = vals;
          } else {
            if (!requestParams.accountManagerUserIds)
              requestParams.accountManagerUserIds = isEmpty(
                this.props.accountManagers,
              )
                ? undefined
                : map(this.props.accountManagers, "id");
          }
        }
        if (
          this.state.requestParams.subscriptionTierId >= 3 &&
          this.state.requestParams.subscriptionTierId != 5
        ) {
          requestData = {
            ...requestParams,
            insightsStandardConfig: {
              maxMonthlyConsumerRecords: parseInt(
                this.state.consumerRecords,
                10,
              ),
              maxMonthlyBusinessRecords: parseInt(
                this.state.businessRecords,
                10,
              ),
              consumerDataSource: this.state.consumerDataSource,
              businessDataSource: this.state.businessDataSource,
            },
            audienceResolutionGranularity: this.state
              .audienceResolutionGranularity,
          };
          if (this.state.requestParams.subscriptionTierId === 4) {
            requestData.insightsStandardConfig["segmentationSystem"] = this
              .state.segmentationSystem
              ? this.state.segmentationSystem
              : "prizm_premier";
            requestData.insightsStandardConfig["appendSegmentation"] = this
              .state.appendSegmentation
              ? this.state.appendSegmentation
              : false;
            if (this.state.appendSegmentation === true) {
              requestData.insightsStandardConfig[
                "segmentationLicenseNumber"
              ] = this.state.licenseNum;
              requestData.insightsStandardConfig["licenseExpirationDate"] =
                this.state.expYear + "-" + this.state.expMonth + "-01";
            } else {
              requestData.insightsStandardConfig[
                "segmentationLicenseNumber"
              ] = null;
              requestData.insightsStandardConfig[
                "licenseExpirationDate"
              ] = null;
            }
          }
        } else {
          requestData = {
            ...requestParams,
            insightsStandardConfig: undefined,
          };
        }
      }

      if (
        this.props.edit_client_profile.subscriptionTierId >= 3 &&
        this.props.edit_client_profile.subscriptionTierId !== 5 &&
        requestData.subscriptionTierId === 2
      ) {
        this.setState({
          showDowngradeConfirm: true,
        });
      } else {
        this.props.updateClientProfile(
          this.props.match.params.businessUnitId,
          requestData,
        );
      }
      //}
    }
    if (
      /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname)
    ) {
      // for edit client profile page

      if (this.state.contractNumberText !== "") {
        return;
      }

      //if (this.state.requestParams.subscriptionTierId >= 3) {
      /*
        // for edit business unit profile and create business unit profile
        this.props.configInsightsStandard(this.props.match.params.businessUnitId, {
          // id: parseInt(this.props.match.params.businessUnitId),
          maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
          maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
          consumerDataSource: this.state.consumerDataSource,
          businessDataSource: 'InfoGroup'
        })*/
      const { requestParams } = this.state;

      if (
        requestParams.accountManagerUserIds &&
        requestParams.accountManagerUserIds.length > 0 &&
        requestParams.accountManagerUserIds[0] === ""
      ) {
        requestParams.accountManagerUserIds = undefined;
      } else {
        if (
          requestParams.accountManagerUserIds &&
          requestParams.accountManagerUserIds.length > 0
        ) {
          if (isNaN(requestParams.accountManagerUserIds[0])) {
            const vals = map(requestParams.accountManagerUserIds, "value");
            requestParams.accountManagerUserIds = vals;
          }
        } else {
          requestParams.accountManagerUserIds = isEmpty(
            this.props.accountManagers,
          )
            ? undefined
            : map(this.props.accountManagers, "id");
        }
      }
      if (
        this.state.requestParams.subscriptionTierId >= 3 &&
        this.state.requestParams.subscriptionTierId != 5
      ) {
        requestData = {
          ...requestParams,
          insightsStandardConfig: {
            maxMonthlyConsumerRecords: parseInt(this.state.consumerRecords, 10),
            maxMonthlyBusinessRecords: parseInt(this.state.businessRecords, 10),
            consumerDataSource: isEmpty(this.state.consumerDataSource)
              ? window.location.href.indexOf("app.") >= 0
                ? "InfoGroup"
                : "Epsilon"
              : this.state.consumerDataSource,
            businessDataSource: isEmpty(this.state.businessDataSource)
              ? "Epsilon"
              : this.state.businessDataSource,
          },
          audienceResolutionGranularity: this.state
            .audienceResolutionGranularity,
        };
        if (this.state.requestParams.subscriptionTierId === 4) {
          requestData.insightsStandardConfig["segmentationSystem"] = this.state
            .segmentationSystem
            ? this.state.segmentationSystem
            : "prizm_premier";
          requestData.insightsStandardConfig["appendSegmentation"] = this.state
            .appendSegmentation
            ? this.state.appendSegmentation
            : false;
          if (this.state.appendSegmentation === true) {
            requestData.insightsStandardConfig[
              "segmentationLicenseNumber"
            ] = this.state.licenseNum;
            requestData.insightsStandardConfig["licenseExpirationDate"] =
              this.state.expYear + "-" + this.state.expMonth + "-01";
          } else {
            requestData.insightsStandardConfig[
              "segmentationLicenseNumber"
            ] = null;
            requestData.insightsStandardConfig["licenseExpirationDate"] = null;
          }
        }
      } else {
        requestData = {
          ...requestParams,
          insightsStandardConfig: undefined,
        };
      }
      //}
      if (
        this.props.edit_client_profile.subscriptionTierId >= 3 &&
        this.props.edit_client_profile.subscriptionTierId != 5 &&
        requestData.subscriptionTierId === 2
      ) {
        this.setState({
          showDowngradeConfirm: true,
        });
      } else {
        this.props.updateClientProfile(
          this.props.match.params.businessUnitId,
          requestData,
        );
      }
    }
    /*
    if (/^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname)) {
      if (/^(administrator|team member)/gi.test(this.props.roleName)) {
        this.setState({
          requestParams: {
            ...this.state.requestParams
          }
        }, () => {
          this.props.updateClientProfile(this.props.match.params.businessUnitId, this.state.requestParams);
        })
      }
    }*/
    this.throttleEditBusinessUnit = true;
  }
  handleClose() {
    this.props.getClientProfile(this.props.match.params.businessUnitId);
    this.setState({
      ifHiddenTopEdit: true,
      ifHiddenLogoEdit: true,
    });
    if (this.props.editMode) {
      this.props.handleCancel();
    }
    this.props.rollbackProfileStatus();
    this.props.resetStandardConfig();
    this.throttleEditBusinessUnit = true;
  }
  handleAddress1(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        address1: value,
      },
    });
  }
  handleAddress2(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        address2: value,
      },
    });
  }
  handleCity(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        city: value,
      },
    });
  }
  handleState(value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        state: value.value,
      },
    });
  }
  handleZipCode(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        zipCode: value,
      },
    });
  }
  handlePhone(e) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        phone: e.target.value,
      },
    });
  }
  handleSuspendUser() {
    this.setState({
      ifShowSuspend: true,
    });
  }
  handleCancelSuspend() {
    this.setState({
      ifShowSuspend: false,
    });
  }
  handleAccountNumber(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        accountNumber: value,
      },
    });
  }
  handleName(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        name: value,
      },
    });
  }
  suspendUser() {
    let clientId = this.props.match.params.businessUnitId;
    let status;
    if (this.state.status === "Suspended") {
      status = "reactivate";
    } else if (this.state.status === "Active") {
      status = "suspend";
    }
    this.props.suspendAndReactivate(clientId, status);
  }
  handleSubscriptionTierChange(value) {
    let obj =
      value >= 3 && value !== 5
        ? {
            consumerDataSource:
              window.location.href.indexOf("app.") >= 0
                ? "InfoGroup"
                : "Epsilon",
            businessDataSource: "InfoGroup",
            requestParams: {
              ...this.state.requestParams,
              subscriptionTierId: value,
            },
          }
        : {
            businessDataSource: this.props.insights_standard_config
              .businessDataSource,
            consumerDataSource: this.props.insights_standard_config
              .consumerDataSource,
            requestParams: {
              ...this.state.requestParams,
              subscriptionTierId: value,
            },
          };
    this.setState(obj, () => {
      if (
        ((value >= 3 && value !== 5) || value === 1) &&
        this.refs.consumer &&
        this.refs.business
      ) {
        this.refs.consumer.value = this.state.consumerRecords;
        this.refs.business.value = this.state.businessRecords;
      }
    });
  }
  filterTitle() {
    if (
      /^\/clients\/edit\/Business-Units\/detail/g.test(
        this.props.location.pathname,
      )
    ) {
      if (
        /^(system administrator|account manager)/gi.test(this.props.roleName)
      ) {
        return "BUSINESS UNIT";
      }
    }
    if (
      /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname)
    ) {
      if (
        /^(system administrator|account manager)/gi.test(this.props.roleName)
      ) {
        return "CLIENT";
      }
      if (/^(administrator|team member)/gi.test(this.props.roleName)) {
        return "BUSINESS UNIT";
      }
    }
  }
  ifShowAssignTo() {
    const ds = this.props.editMode
      ? /^\/clients\/edit\/Client-Profile/g.test(
          this.props.location.pathname,
        ) && /^administrator/gi.test(this.props.roleName)
        ? this.props.teamMember_options
        : this.props.account_manager
      : this.props.teamMember_options;

    if (/^(system administrator)/gi.test(this.props.roleName)) {
      return true && !isEmpty(ds);
    } else if (
      /^account manager/gi.test(this.props.roleName) &&
      /^\/clients\/edit\/Business-Units\/detail/g.test(
        this.props.location.pathname,
      )
    ) {
      return true && !isEmpty(ds);
    } else if (
      /^administrator/gi.test(this.props.roleName) &&
      (/^\/clients\/edit\/Business-Units\/detail/g.test(
        this.props.location.pathname,
      ) ||
        /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname))
    ) {
      return true && !isEmpty(ds);
    } else if (
      /^team member/gi.test(this.props.roleName) &&
      /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname)
    ) {
      return false;
    }
  }
  handleConsumerRecords(e) {
    if (e.target.value > 1000000) {
      this.refs.consumer.value = 1000000;
    } else if (!/^[0-9]*$/g.test(e.target.value)) {
      this.refs.consumer.value = 0;
    } else {
      this.setState({
        consumerRecords: e.target.value,
      });
    }
  }
  handleBusinessRecords(e) {
    if (e.target.value > 1000000) {
      this.refs.business.value = 1000000;
    } else if (!/^[0-9]*$/g.test(e.target.value)) {
      this.refs.business.value = 0;
    } else {
      this.setState({
        businessRecords: e.target.value,
      });
    }
  }
  handle3rdPartyData(e, value) {
    this.setState({
      consumerDataSource: value, //id === 1 ? value : 'InfoGroup'
    });
  }
  handleBusinessData(e, value) {
    this.setState({
      businessDataSource: value, //id === 1 ? value : 'InfoGroup'
    });
  }
  handleSalesforceId(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        salesForceId: value,
      },
    });
  }
  handleChangeSalesforceId(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        salesForceId: value,
      },
    });
  }
  handleEmail(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        email: value,
      },
    });
  }
  handleChangeEmail(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        email: value,
      },
    });
  }
  handleContractNumber(e, value) {
    if (value === "" && /^(account manager)/gi.test(this.props.roleName)) {
      this.setState({
        ifShowContractNumber: true,
        contractNumberText: "Please add a contract number",
      });
    } else if (
      value === "" &&
      /^(system administrator)/gi.test(this.props.roleName)
    ) {
      this.setState({
        requestParams: {
          ...this.state.requestParams,
          contractNumber: null,
        },
        contractNumberText: "",
        ifShowContractNumber: false,
      });
    } else if (!/^[0-9]{8}$/g.test(value) && value !== "") {
      this.setState({
        ifShowContractNumber: true,
        requestParams: {
          ...this.state.requestParams,
        },
        contractNumberText: "The contract number must be an 8 byte integer",
      });
    } else {
      this.setState({
        requestParams: {
          ...this.state.requestParams,
          contractNumber: value,
        },
        ifShowContractNumber: false,
        contractNumberText: "",
      });
    }
    // else if (value === '') {
    //   this.setState({
    //     ifShowContractNumber: true,
    //     contractNumberText: 'Please add a contract number'
    //   })
    // } else {
    //   this.setState({
    //     ifShowContractNumber: false,
    //     contractNumberText: 'Please add a contract number'
    //   })
    // }
  }
  handelChangeContractNumb(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        contractNumber: value,
      },
    });
  }
  handledReportTypeChanged(value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        campaignReportPreference: value,
      },
    });
  }
  handleTopLocationReportCheck(e, isChecked) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        clientReportDetailSetting: {
          topLocationChannelReport: isChecked ? 1 : 0,
        },
      },
    });
  }
  handleSegmentationSystem(e, value) {
    this.setState({
      segmentationSystem: value,
    });
  }
  handleAppendSegment(e, value) {
    this.setState({
      appendSegmentation: value === "append_seg" ? true : false,
    });
  }
  handleLicenseNumber(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
      },
      licenseNum: value,
    });
  }
  handleExpMonthChange(value) {
    this.setState({
      expMonth: value.value,
    });
  }
  handleExpYearChange(value) {
    this.setState({
      expYear: value.value,
    });
  }
  saveDowngradeClient(e) {
    e.preventDefault();
    this.props.updateClientProfile(
      this.props.match.params.businessUnitId,
      this.state.requestParams,
    );
    this.setState({ showDowngradeConfirm: false });
  }
  handleAccoundDownloadOptions(e, value) {
    this.setState({
      audienceResolutionGranularity: value,
    });
  }
  renderAccountDownloadConfig() {
    return this.state.ifHiddenTopEdit ? (
      <div
        className="role clearfix"
        style={{
          lineHeight: "33px",
          borderBottom: "solid 1px #E8EBEF",
          marginBottom: "0px",
        }}
      >
        <p
          style={{
            float: "left",
            color: "#000",
            fontWeight: "bolder",
            width: "30%",
            fontSize: "16px",
            marginBottom: "0px",
          }}
        >
          Desired Granularity<em style={{ color: "red" }}>*</em>
        </p>
        <div className="pl-10" style={{ float: "left" }}>
          {this.state.audienceResolutionGranularity}
        </div>
      </div>
    ) : (
      <div
        className="clearfix"
        style={{
          paddingTop: "16px",
          paddingBottom: "16px",
          borderTop: "1px solid #B1B0B0",
        }}
      >
        <div
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            paddingBottom: "20px",
          }}
        >
          Account Download Options
        </div>
        <p
          style={{
            float: "left",
            fontWeight: "bolder",
            width: "30%",
            lineHeight: "1.2",
          }}
        >
          Desired Granularity<em style={{ color: "red" }}>*</em>
        </p>
        <div
          style={{
            float: "left",
            marginBottom: "20px",
            minWidth: "400px",
            width: "60%",
          }}
        >
          <RadioButtonGroup
            name="download"
            valueSelected={this.state.audienceResolutionGranularity}
            onChange={(e, value) => this.handleAccoundDownloadOptions(e, value)}
          >
            <RadioButton
              value="Precision"
              label="Precision: Z+6 matches only"
              iconStyle={{ fill: "black", width: "20px", height: "20px" }}
            />
            <RadioButton
              value="Scale"
              label="Scale: Z+6 matches where available/ Z+4 fallback"
              iconStyle={{ fill: "black", width: "20px", height: "20px" }}
            />
          </RadioButtonGroup>
        </div>
      </div>
    );
  }
  renderProfessionalConfig() {
    return (
      <div
        className="clearfix"
        style={{
          display: this.state.ifHiddenTopEdit ? "none" : "block",
          paddingTop: "16px",
          paddingBottom: "16px",
          marginBottom: "30px",
          borderTop: "1px solid #B1B0B0",
          borderBottom: "1px solid #B1B0B0",
        }}
      >
        {this.state.requestParams.subscriptionTierId === 4 && (
          <div
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              paddingBottom: "20px",
            }}
          >
            Professional Subscription Tier
          </div>
        )}
        <p style={{ float: "left", fontWeight: "bolder", width: "30%" }}>
          Maximum Monthly Records<em style={{ color: "red" }}>*</em>
        </p>
        <div style={{ float: "left", width: "60%" }}>
          <label style={{ fontWeight: "bold" }}>Consumer</label>
          {this.state.requestParams.subscriptionTierId === 1 && (
            <div>
              {/*
              <RadioButtonGroup name="consumer" defaultSelected='InfoGroup' onChange={(e, value) => this.handle3rdPartyData(e, value)}>
                <RadioButton
                  value="InfoGroup"
                  label="InfoGroup"
                  iconStyle={{fill: 'black', width: '20px', height: '20px'}}
                />
                <RadioButton
                  value="Experian"
                  label="Experian"
                  disabled={!(this.state.requestParams.subscriptionTierId === 1)}
                  iconStyle={{fill: 'black', width: '20px', height: '20px'}}
                />
            </RadioButtonGroup>*/}
              <section style={{ marginBottom: "29px" }}>
                <span>
                  Maximum Monthly Consumer Records{" "}
                  <input
                    disabled={/^(administrator|team member)/gi.test(
                      this.props.roleInfo,
                    )}
                    onBlur={(e) => this.handleConsumerRecords(e)}
                    ref="consumer"
                    type="text"
                    style={{
                      textAlign: "center",
                      border: /^(administrator|team member)/gi.test(
                        this.props.roleInfo,
                      )
                        ? "none"
                        : "1px solid #B1B0B0",
                      width: "49px",
                      height: "30px",
                      marginLeft: /^(administrator|team member)/gi.test(
                        this.props.roleInfo,
                      )
                        ? "0"
                        : "15px",
                    }}
                  />
                </span>
              </section>
            </div>
          )}
          {this.state.requestParams.subscriptionTierId >= 3 &&
            this.state.requestParams.subscriptionTierId != 5 && (
              <div>
                {/*
              <RadioButtonGroup name="consumer" defaultSelected='InfoGroup' onChange={(e, value) => this.handle3rdPartyData(e, value)}>
                <RadioButton
                  value="InfoGroup"
                  label="InfoGroup"
                  iconStyle={{fill: 'black', width: '20px', height: '20px'}}
                />
                <RadioButton
                  value="Experian"
                  label="Experian"
                  disabled={!(this.state.requestParams.subscriptionTierId === 1)}
                  iconStyle={{fill: 'black', width: '20px', height: '20px'}}
                />
            </RadioButtonGroup>*/}
                <section style={{ marginBottom: "29px" }}>
                  <span>
                    Maximum Monthly Consumer Records4{" "}
                    <input
                      disabled={/^(administrator|team member)/gi.test(
                        this.props.roleInfo,
                      )}
                      onBlur={(e) => this.handleConsumerRecords(e)}
                      ref="consumer"
                      type="text"
                      style={{
                        textAlign: "center",
                        border: /^(administrator|team member)/gi.test(
                          this.props.roleInfo,
                        )
                          ? "none"
                          : "1px solid #B1B0B0",
                        width: "49px",
                        height: "30px",
                        marginLeft: /^(administrator|team member)/gi.test(
                          this.props.roleInfo,
                        )
                          ? "0"
                          : "15px",
                      }}
                    />
                  </span>
                </section>
              </div>
            )}
          <label style={{ fontWeight: "bold" }}>Business</label>
          {/*
        <RadioButtonGroup name="Business" defaultSelected="InfoGroup">
          <RadioButton
            value="InfoGroup"
            label="InfoGroup"
            iconStyle={{fill: 'black', width: '20px', height: '20px'}}
          />
        </RadioButtonGroup>*/}
          <section>
            <span>
              Maximum Monthly Business Records{" "}
              <input
                disabled={/^(administrator|team member)/gi.test(
                  this.props.roleInfo,
                )}
                onBlur={(e) => this.handleBusinessRecords(e)}
                ref="business"
                type="text"
                style={{
                  textAlign: "center",
                  border: /^(administrator|team member)/gi.test(
                    this.props.roleInfo,
                  )
                    ? "none"
                    : "1px solid #B1B0B0",
                  width: "49px",
                  height: "30px",
                  marginLeft: /^(administrator|team member)/gi.test(
                    this.props.roleInfo,
                  )
                    ? "8px"
                    : "22px",
                }}
              />
            </span>
          </section>
        </div>
        {this.state.requestParams.subscriptionTierId >= 3 &&
          this.state.requestParams.subscriptionTierId != 5 && (
            <p
              style={{
                float: "left",
                marginTop: "20px",
                fontWeight: "bolder",
                width: "30%",
              }}
            >
              Data Source - Consumer
            </p>
          )}
        {this.state.requestParams.subscriptionTierId >= 3 && (
          <div
            style={{
              float: "left",
              marginTop: "20px",
              marginBottom: "20px",
              minWidth: "400px",
              width: "60%",
            }}
          >
            <RadioButtonGroup
              name="consumer"
              valueSelected={
                this.state.consumerDataSource
                  ? this.state.consumerDataSource
                  : window.location.href.indexOf("app.") >= 0
                  ? "InfoGroup"
                  : "Epsilon"
              }
              onChange={(e, value) => this.handle3rdPartyData(e, value)}
            >
              <RadioButton
                value="InfoGroup"
                label="InfoGroup"
                iconStyle={{ fill: "black", width: "20px", height: "20px" }}
              />
              <RadioButton
                value="Epsilon"
                label="Epsilon"
                disabled={window.location.href.indexOf("app.") >= 0}
                /*disabled={!(this.state.requestParams.subscriptionTierId === 1)}*/
                iconStyle={{ fill: "black", width: "20px", height: "20px" }}
              />
            </RadioButtonGroup>
          </div>
        )}
        {this.state.requestParams.subscriptionTierId >= 3 &&
          this.state.requestParams.subscriptionTierId != 5 && (
            <p
              style={{
                float: "left",
                marginTop: "20px",
                fontWeight: "bolder",
                width: "30%",
              }}
            >
              Data Source - Business
            </p>
          )}
        {this.state.requestParams.subscriptionTierId >= 3 &&
          this.state.requestParams.subscriptionTierId != 5 && (
            <div
              style={{
                float: "left",
                marginTop: "20px",
                marginBottom: "20px",
                minWidth: "400px",
                width: "60%",
              }}
            >
              <RadioButtonGroup
                name="business"
                valueSelected={
                  this.state.businessDataSource
                    ? this.state.businessDataSource
                    : "InfoGroup"
                }
                onChange={(e, value) => this.handleBusinessData(e, value)}
              >
                <RadioButton
                  value="InfoGroup"
                  label="InfoGroup"
                  iconStyle={{ fill: "black", width: "20px", height: "20px" }}
                />
              </RadioButtonGroup>
            </div>
          )}
        {this.state.requestParams.subscriptionTierId == 4 && (
          <p
            style={{
              float: "left",
              marginTop: "20px",
              fontWeight: "bolder",
              width: "30%",
            }}
          >
            Segmentation System
          </p>
        )}
        {this.state.requestParams.subscriptionTierId == 4 && (
          <div
            style={{
              float: "left",
              marginTop: "20px",
              marginBottom: "20px",
              minWidth: "400px",
              width: "60%",
            }}
          >
            <RadioButtonGroup
              name="segmentation"
              valueSelected={
                this.state.segmentationSystem
                  ? this.state.segmentationSystem
                  : "prizm_premier"
              }
              onChange={(e, value) => this.handleSegmentationSystem(e, value)}
            >
              <RadioButton
                value="prizm_premier"
                label="PRIZM Premier"
                iconStyle={{ fill: "black", width: "20px", height: "20px" }}
              />
              <RadioButton
                value="psycle_premier"
                label="P$YCLE Premier"
                iconStyle={{ fill: "black", width: "20px", height: "20px" }}
              />
              <RadioButton
                value="connexions"
                label="ConneXions"
                iconStyle={{ fill: "black", width: "20px", height: "20px" }}
              />
            </RadioButtonGroup>
          </div>
        )}
        {this.state.requestParams.subscriptionTierId > 4 && (
          <p
            style={{
              float: "left",
              marginTop: "20px",
              fontWeight: "bolder",
              width: "30%",
            }}
          >
            Append Segmentation to File
          </p>
        )}
        {this.state.requestParams.subscriptionTierId > 4 && (
          <div
            style={{
              float: "left",
              marginTop: "20px",
              marginBottom: "20px",
              minWidth: "400px",
            }}
          >
            <RadioButtonGroup
              name="segmentation"
              defaultSelected="no_append_seg"
              valueSelected={
                this.state.appendSegmentation &&
                this.state.appendSegmentation === true
                  ? "append_seg"
                  : "no_append_seg"
              }
              onChange={(e, value) => this.handleAppendSegment(e, value)}
            >
              <RadioButton
                value="append_seg"
                label="Yes"
                iconStyle={{ fill: "black", width: "20px", height: "20px" }}
              />
              <RadioButton
                value="no_append_seg"
                label="No"
                iconStyle={{ fill: "black", width: "20px", height: "20px" }}
              />
            </RadioButtonGroup>
          </div>
        )}
        {this.state.requestParams.subscriptionTierId > 4 &&
          this.state.appendSegmentation && (
            <div className="profile-fn-wrapper">
              <InputField
                labelTitle={"Segmentation License Number"}
                ifRequireField={true}
                borderColor={"#B1B0B0"}
                onChange={(e, value) => this.handleLicenseNumber(e, value)}
                initValue={
                  this.state.licenseNum === null ? "" : this.state.licenseNum
                }
                borderCorlor="#B1B0B0"
                labelStyle={{
                  float: "left",
                  fontWeight: "bolder",
                  width: "50%",
                  margin: 0,
                  lineHeight: "18px",
                  marginTop: "8px",
                }}
                inputContainerId="licenseNumber"
                style={{
                  height: "32px",
                  lineHeight: "32px",
                  marginBottom: "30px",
                  zIndex: 2000,
                  width: "60%",
                }}
              />
            </div>
          )}
        {this.state.requestParams.subscriptionTierId > 4 &&
          this.state.appendSegmentation && (
            <div
              className="role clearfix"
              style={{
                lineHeight: "32px",
                position: "relative",
                marginTop: "150px",
              }}
            >
              <p
                style={{
                  color: "black",
                  float: "left",
                  width: "30%",
                  margin: 0,
                  fontWeight: "bolder",
                  position: "absolute",
                  bottom: "5px",
                }}
              >
                Expiration Date<em style={{ color: "red" }}>*</em>
              </p>
              <div
                className="content clearfix "
                style={{ width: "65%", paddingLeft: "30%" }}
              >
                <Select
                  className="date-selector month-selector z-index-199"
                  value={this.state.expMonth}
                  clearable={false}
                  options={this.state.months}
                  onChange={(date) => this.handleExpMonthChange(date)}
                  placeholder={"MM"}
                />
                <span
                  className="pl-10 pr-10"
                  style={{ position: "absolute", bottom: "10px" }}
                >
                  -
                </span>
                <Select
                  className="date-selector year-selector z-index-199"
                  value={this.state.expYear}
                  clearable={false}
                  options={this.state.years}
                  onChange={(date) => this.handleExpYearChange(date)}
                  placeholder={"YYYY"}
                />
              </div>
            </div>
          )}
        {this.state.requestParams.subscriptionTierId == 4 &&
          this.state.appendSegmentation && (
            <div className="profile-fn-wrapper" style={{ marginTop: "1em" }}>
              {this.state.licenseErrorText &&
                this.state.licenseErrorText !== "" && (
                  <section className="create-profile-error clearfix">
                    <Error style={{ float: "left" }} color="red" />
                    <span>{this.state.licenseErrorText}</span>
                  </section>
                )}
            </div>
          )}
      </div>
    );
  }
  render() {
    const actions = [
      <FlatButton
        label="Close"
        primary={true}
        backgroundColor={buttonBlueColor()}
        labelStyle={{ color: "white" }}
        hoverColor={buttonBlueColor()}
        onClick={() => this.handleCloseDialog()}
      />,
    ];
    const isEmptyAccIds =
      !this.state.requestParams.accountManagerUserIds ||
      isEmpty(this.state.requestParams.accountManagerUserIds) ||
      this.state.requestParams.accountManagerUserIds[0] === "";
    const { roleName } = this.props;
    console.log(roleName);
    return (
      <div
        className="edit-client-profile"
        style={{
          padding:
            /^(administrator|team member|system administrator|account manager)/gi.test(
              this.props.roleName,
            ) && this.props.editMode
              ? "0"
              : "",
        }}
      >
        <div className="edit-client-box">
          {this.state.ifHiddenTopEdit && (
            <div className="edit-client-shadow"></div>
          )}
          <h4
            style={{
              display: !this.state.ifHiddenTopEdit ? "block" : "none",
              fontWeight: "bolder",
              fontSize: "24px",
              marginTop: "0",
              marginBottom: "20px",
            }}
          >
            CHANGE{" "}
            {/^(system administrator|account manager)/gi.test(
              this.props.roleName,
            )
              ? /^\/clients\/edit\/Business-Units/g.test(
                  this.props.location.pathname,
                )
                ? "BUSSINESS UNIT"
                : "CLIENT"
              : "BUSINESS UNIT"}{" "}
            PROFILE
          </h4>
          <a
            href={`/clients/edit/Business-Units/detail/Team Members/${this.props.match.params.id}?name=${this.props.edit_client_profile.name}&id=${this.props.edit_client_profile.id}`}
            style={{
              display:
                this.state.ifHiddenTopEdit &&
                /^\/clients\/edit\/Business-Units\/detail/gi.test(
                  this.props.location.pathname,
                )
                  ? "block"
                  : "none",
              textAlign: "right",
              margin: this.state.ifHiddenTopEdit ? "" : "0 13px 20px 0",
            }}
          >
            View Team Members
          </a>
          <div className="profile-fn-wrapper">
            <InputField
              labelTitle={
                /^(system administrator|account manager)/gi.test(
                  this.props.roleName,
                )
                  ? /^\/clients\/edit\/Business-Units/g.test(
                      this.props.location.pathname,
                    )
                    ? "Business Unit Name"
                    : "Client Name"
                  : "Business Unit Name"
              }
              onChange={(e, value) => this.handleName(e, value)}
              ifHasBorder={this.state.ifHiddenTopEdit}
              initValue={this.state.requestParams.name}
              hintText={this.state.requestParams.name}
              ifRequireField={true}
              borderColor="#B1B0B0"
              labelStyle={{
                float: "left",
                fontSize: "16px",
                fontWeight: "bolder",
                width: "30%",
                margin: 0,
              }}
              inputContainerId="firstName"
              style={{
                lineHeight: "33px",
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "",
                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
              }}
            />
          </div>
          <div
            className="profile-fn-wrapper clearfix"
            style={{
              lineHeight: "33px",
              borderBottom: this.state.ifHiddenTopEdit
                ? "1px solid #E8EBEF"
                : "none",
              marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px",
            }}
          >
            <span
              style={{
                float: "left",
                fontSize: "16px",
                fontWeight: "bolder",
                width: "30%",
              }}
            >
              Profile Creation Date
            </span>
            <strong
              style={{
                float: "left",
                paddingLeft: "10px",
                fontWeight: "normal",
              }}
            >
              {this.props.edit_client_profile.createdTime &&
                moment(this.props.edit_client_profile.createdTime).format(
                  "M/D/YYYY",
                )}
            </strong>
          </div>
          <div
            className="profile-fn-wrapper clearfix"
            style={{
              lineHeight: "33px",
              borderBottom: this.state.ifHiddenTopEdit
                ? "1px solid #E8EBEF"
                : "none",
              marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px",
            }}
          >
            <span
              style={{
                float: "left",
                fontSize: "16px",
                fontWeight: "bolder",
                width: "30%",
              }}
            >
              Status
            </span>
            <strong
              style={{
                float: "left",
                paddingLeft: "10px",
                fontWeight: "normal",
              }}
            >
              {this.state.requestParams.status}
            </strong>
          </div>
          <div className="profile-fn-wrapper">
            <InputField
              labelTitle={
                /^(system administrator|account manager)/gi.test(
                  this.props.roleName,
                )
                  ? /^\/clients\/edit\/Business-Units/g.test(
                      this.props.location.pathname,
                    )
                    ? "Business Unit Address 1"
                    : "Client Address 1"
                  : "Business Unit Address 1"
              }
              onChange={(e, value) => this.handleAddress1(e, value)}
              ifHasBorder={this.state.ifHiddenTopEdit}
              initValue={this.state.requestParams.address1}
              hintText={this.state.requestParams.address1}
              borderColor="#B1B0B0"
              labelStyle={{
                float: "left",
                fontSize: "16px",
                fontWeight: "bolder",
                width: "30%",
                margin: 0,
              }}
              inputContainerId="firstName"
              style={{
                lineHeight: "33px",
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "",
                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
              }}
            />
          </div>
          <div className="profile-fn-wrapper">
            <InputField
              labelTitle={
                /^(system administrator|account manager)/gi.test(
                  this.props.roleName,
                )
                  ? /^\/clients\/edit\/Business-Units/g.test(
                      this.props.location.pathname,
                    )
                    ? "Business Unit Address 2"
                    : "Client Address 2"
                  : "Business Unit Address 2"
              }
              onChange={(e, value) => this.handleAddress2(e, value)}
              ifHasBorder={this.state.ifHiddenTopEdit}
              initValue={this.state.requestParams.address2}
              hintText={this.state.requestParams.address2}
              borderColor="#B1B0B0"
              labelStyle={{
                float: "left",
                fontSize: "16px",
                fontWeight: "bolder",
                width: "30%",
                margin: 0,
              }}
              inputContainerId="firstName"
              style={{
                lineHeight: "33px",
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "",
                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
              }}
            />
          </div>
          <div className="profile-fn-wrapper">
            <InputField
              labelTitle="City"
              onChange={(e, value) => this.handleCity(e, value)}
              ifHasBorder={this.state.ifHiddenTopEdit}
              initValue={this.state.requestParams.city}
              hintText={this.state.requestParams.city}
              borderColor="#B1B0B0"
              labelStyle={{
                float: "left",
                fontSize: "16px",
                fontWeight: "bolder",
                width: "30%",
                margin: 0,
              }}
              inputContainerId="firstName"
              style={{
                lineHeight: "33px",
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "",
                marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
              }}
            />
          </div>
          <div
            className="role clearfix"
            style={{
              lineHeight: "33px",
              borderBottom: this.state.ifHiddenTopEdit
                ? "1px solid #E8EBEF"
                : "",
              marginBottom: !this.state.ifHiddenTopEdit ? "26px" : "0",
            }}
          >
            <p
              style={{
                color: "black",
                fontSize: "16px",
                float: "left",
                width: "30%",
                margin: 0,
                fontWeight: "bolder",
              }}
            >
              State
            </p>
            {this.state.ifHiddenTopEdit ? (
              <div className="pull-left pl-10" style={{ width: "70%" }}>
                {this.state.stateValue}
              </div>
            ) : (
              <Select
                className="client-profile-timezone edit-state"
                value={this.state.requestParams.state}
                clearable={false}
                options={this.props.allstates}
                onChange={(value) => this.handleState(value)}
              />
            )}
          </div>
          <div className="profile-fn-wrapper">
            <InputField
              labelTitle="Zip Code"
              onChange={(e, value) => this.handleZipCode(e, value)}
              ifHasBorder={this.state.ifHiddenTopEdit}
              initValue={this.state.requestParams.zipCode}
              hintText={this.state.requestParams.zipCode}
              borderColor="#B1B0B0"
              labelStyle={{
                float: "left",
                fontSize: "16px",
                fontWeight: "bolder",
                width: "30%",
                margin: 0,
              }}
              inputContainerId="firstName"
              style={{
                lineHeight: "33px",
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "",
                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : 0,
              }}
            />
          </div>
          <div
            className="role clearfix"
            style={{
              lineHeight: "33px",
              borderBottom: this.state.ifHiddenTopEdit
                ? "1px solid #E8EBEF"
                : "",
              marginBottom: !this.state.ifHiddenTopEdit ? "26px" : "0",
            }}
          >
            <p
              style={{
                color: "black",
                fontSize: "16px",
                float: "left",
                width: "30%",
                margin: 0,
                fontWeight: "bolder",
              }}
            >
              Time Zone<em style={{ color: "red" }}>*</em>
            </p>
            {this.state.ifHiddenTopEdit ? (
              <div className="pull-left pl-10" style={{ width: "70%" }}>
                {this.state.timezoneValue}
              </div>
            ) : (
              <Select
                className="client-profile-timezone edit-timezone"
                value={this.state.requestParams.timezone}
                clearable={false}
                searchable={false}
                options={this.props.timezone}
                onChange={(value) => this.handleTimeZoneChange(value)}
              />
            )}
          </div>
          <div
            className="profile-mobile-phone-number clearfix"
            style={{
              borderBottom: this.state.ifHiddenTopEdit
                ? "1px solid #E8EBEF"
                : "",
              marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px",
            }}
          >
            <span
              style={{ marginTop: this.state.ifHiddenTopEdit ? "" : "10px" }}
            >
              Phone Number
            </span>
            <MaskedInput
              className="mp-mask"
              guide={false}
              value={this.state.requestParams.phone}
              style={{
                border: this.state.ifHiddenTopEdit ? "" : "1px solid #B1B0B0",
                height: this.state.ifHiddenTopEdit ? "" : "32px",
              }}
              mask={[
                "(",
                /[1-9]/,
                /\d/,
                /\d/,
                ")",
                " ",
                /\d/,
                /\d/,
                /\d/,
                "-",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ]}
              onChange={(e) => this.handlePhone(e)}
            />
          </div>
          <div className="profile-fn-wrapper">
            <InputField
              labelTitle="Account Number"
              onChange={(e, value) => this.handleAccountNumber(e, value)}
              ifHasBorder={this.state.ifHiddenTopEdit}
              initValue={this.state.requestParams.accountNumber}
              hintText={this.state.requestParams.accountNumber}
              borderColor="#B1B0B0"
              labelStyle={{
                float: "left",
                fontSize: "16px",
                fontWeight: "bolder",
                width: "30%",
                margin: 0,
              }}
              inputContainerId="firstName"
              style={{
                lineHeight: "33px",
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "",
                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : 0,
              }}
            />
          </div>
          {/^(\/clients\/edit\/Client-Profile)/g.test(
            this.props.location.pathname,
          ) &&
            /^(account manager|system administrator)/gi.test(
              this.props.roleName,
            ) && (
              <div className="profile-fn-wrapper">
                <InputField
                  labelTitle="Contract Number"
                  handleOnBlur={(e, value) =>
                    this.handleContractNumber(e, value)
                  }
                  onChange={(e, value) =>
                    this.handelChangeContractNumb(e, value)
                  }
                  ifHasBorder={this.state.ifHiddenTopEdit}
                  initValue={
                    this.state.requestParams.contractNumber === null
                      ? ""
                      : this.state.requestParams.contractNumber
                  }
                  hintText={this.state.requestParams.contractNumber}
                  borderColor="#B1B0B0"
                  ifRequireField={/^(account manager)/gi.test(
                    this.props.roleName,
                  )}
                  labelStyle={{
                    float: "left",
                    fontSize: "16px",
                    fontWeight: "bolder",
                    width: "30%",
                    margin: 0,
                  }}
                  inputContainerId="firstName"
                  style={{
                    lineHeight: "33px",
                    borderBottom: this.state.ifHiddenTopEdit
                      ? "1px solid #E8EBEF"
                      : "",
                    marginBottom: !this.state.ifHiddenTopEdit ? "26px" : 0,
                  }}
                />
                {this.state.ifShowContractNumber && (
                  <p className="create-account-field-error clearfix">
                    <Error style={{ float: "left" }} color="red" />
                    <span>{this.state.contractNumberText}</span>
                  </p>
                )}
              </div>
            )}
          {
            <div className="profile-fn-wrapper">
              <InputField
                maxLength={20}
                labelTitle="Salesforce ID"
                handleOnBlur={(e, value) => this.handleSalesforceId(e, value)}
                onChange={(e, value) => this.handleChangeSalesforceId(e, value)}
                ifHasBorder={this.state.ifHiddenTopEdit}
                initValue={
                  this.state.requestParams.salesForceId === null
                    ? ""
                    : this.state.requestParams.salesForceId
                }
                hintText={this.state.requestParams.salesForceId}
                borderColor="#B1B0B0"
                ifRequireField={false}
                labelStyle={{
                  float: "left",
                  fontSize: "16px",
                  fontWeight: "bolder",
                  width: "30%",
                  margin: 0,
                }}
                inputContainerId="firstName"
                style={{
                  lineHeight: "33px",
                  borderBottom: this.state.ifHiddenTopEdit
                    ? "1px solid #E8EBEF"
                    : "",
                  marginBottom: !this.state.ifHiddenTopEdit ? "26px" : 0,
                }}
              />
            </div>
          }
          {/*when is client profile show below*/}
          {/^(system administrator|account manager|administrator|team member)/gi.test(
            this.props.roleName,
          ) &&
            /^(\/clients\/edit\/Client-Profile|\/clients\/edit\/Business-Units\/detail)/g.test(
              this.props.location.pathname,
            ) && (
              /*
              <div className="role clearfix" style={{lineHeight: '33px', borderBottom: this.state.ifHiddenTopEdit ? '1px solid #E8EBEF' : '', marginBottom: !this.state.ifHiddenTopEdit ? '13px' : '0'}}>
                <p style={{ marginTop: '7px', color: 'black', fontSize: '16px', float: 'left', width: '30%', margin: 0, fontWeight: 'bolder' }}>Subscription Tier<em style={{ color: 'red'}}>*</em></p>
                {this.state.ifHiddenTopEdit  ? (<div className="pull-left pl-10" style={{width: '68%'}}>{this.state.subscription.name}</div>):
                  (<Select
                    className="client-profile-stimezone edit-subscription"
                    value={this.state.requestParams.subscriptionTierId}
                    clearable={false}
                    searchable={false}
                    options={/^(\/clients\/edit\/Business-Units\/detail)/g.test(this.props.location.pathname) ||
                    (/^(administrator|team member)/gi.test(this.props.roleName) && /^(\/clients\/edit\/Client-Profile)/g.test(this.props.location.pathname)) ?
                      this.props.tier_options.filter(item => item.value !== 1) :
                      this.props.tier_options}
                    onChange={(value) => this.handleSubscriptionTierChange(value)}
                  />)}
              </div>*/
              <div
                className="role clearfix"
                style={{
                  lineHeight: "33px",
                  borderBottom: this.state.ifHiddenTopEdit
                    ? "1px solid #E8EBEF"
                    : "",
                  marginBottom: !this.state.ifHiddenTopEdit ? "16px" : "0",
                }}
              >
                <p
                  style={{
                    color: "black",
                    fontSize: "16px",
                    float: "left",
                    width: "30%",
                    margin: 0,
                    fontWeight: "bolder",
                  }}
                >
                  Subscription Tier <em style={{ color: "red" }}>*</em>
                </p>
                <div style={{ float: "left" }}>
                  {this.state.ifHiddenTopEdit ? (
                    <div className="ml-10">
                      {this.state.requestParams.subscriptionTierId &&
                        (this.state.requestParams.subscriptionTierId === 2
                          ? "Basic"
                          : this.state.requestParams.subscriptionTierId === 3
                          ? "Standard"
                          : "Professional")}
                    </div>
                  ) : (
                    <RadioButtonGroup
                      name="clientTier"
                      valueSelected={
                        this.state.requestParams.subscriptionTierId
                      }
                      onChange={(e, value) =>
                        this.handleSubscriptionTierChange(value)
                      }
                    >
                      <RadioButton
                        value={2}
                        label="Basic"
                        iconStyle={{
                          fill: "black",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                      <RadioButton
                        value={3}
                        label="Standard"
                        iconStyle={{
                          fill: "black",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                      <RadioButton
                        value={4}
                        label="Professional"
                        iconStyle={{
                          fill: "black",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                      <RadioButton
                        value={5}
                        disabled={/^\/clients\/edit\/Business-Units/g.test(
                          this.props.location.pathname,
                        )}
                        label="Optimize"
                        iconStyle={{
                          fill: "black",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </RadioButtonGroup>
                  )}
                </div>
              </div>
            )}
          {/^(\/clients\/edit\/Client-Profile|\/clients\/edit\/Business-Units\/detail)/g.test(
            this.props.location.pathname,
          ) &&
            /^(account manager|system administrator)/gi.test(
              this.props.roleName,
            ) &&
            this.state.requestParams.subscriptionTierId === 5 && (
              <div className="profile-fn-wrapper">
                <InputField
                  labelTitle="Email"
                  handleOnBlur={(e, value) => this.handleEmail(e, value)}
                  onChange={(e, value) => this.handleChangeEmail(e, value)}
                  ifHasBorder={this.state.ifHiddenTopEdit}
                  initValue={
                    this.state.requestParams.email === null
                      ? ""
                      : this.state.requestParams.email
                  }
                  hintText={this.state.requestParams.email}
                  borderColor="#B1B0B0"
                  ifRequireField={true}
                  labelStyle={{
                    float: "left",
                    fontSize: "16px",
                    fontWeight: "bolder",
                    width: "30%",
                    margin: 0,
                  }}
                  inputContainerId="firstName"
                  style={{
                    lineHeight: "33px",
                    borderBottom: this.state.ifHiddenTopEdit
                      ? "1px solid #E8EBEF"
                      : "",
                    marginBottom: !this.state.ifHiddenTopEdit ? "26px" : 0,
                  }}
                />
                {this.state.requiredEmailText && (
                  <p className="create-account-field-error clearfix">
                    <Error style={{ float: "left" }} color="red" />
                    <span>{this.state.requiredEmailText}</span>
                  </p>
                )}
              </div>
            )}
          {this.state.requestParams.subscriptionTierId >= 3 &&
            this.state.requestParams.subscriptionTierId != 5 &&
            /^(system administrator|account manager)/gi.test(
              this.props.roleName,
            ) &&
            /^(\/clients\/edit\/Business-Units\/detail)/g.test(
              this.props.location.pathname,
            ) &&
            this.state.ifHiddenTopEdit && (
              <div
                className="role clearfix"
                style={{
                  lineHeight: "33px",
                  borderBottom: "solid 1px #E8EBEF",
                  marginBottom: "0px",
                }}
              >
                <p
                  style={{
                    float: "left",
                    color: "#000",
                    fontWeight: "bolder",
                    width: "30%",
                    fontSize: "16px",
                    marginBottom: "0px",
                  }}
                >
                  Data Source<em style={{ color: "red" }}>*</em>
                </p>
                <div className="pl-10" style={{ float: "left" }}>
                  <section>
                    <strong>Consumer</strong> - {this.state.consumerDataSource}
                  </section>
                  <section>
                    <strong>Business</strong> - {this.state.businessDataSource}
                  </section>
                </div>
              </div>
            )}
          {this.state.requestParams.subscriptionTierId >= 3 &&
            this.state.requestParams.subscriptionTierId != 5 &&
            /^(system administrator|account manager)/gi.test(
              this.props.roleName,
            ) &&
            /^(\/clients\/edit\/Business-Units\/detail)/g.test(
              this.props.location.pathname,
            ) &&
            this.renderAccountDownloadConfig()}
          {this.state.requestParams.subscriptionTierId >= 3 &&
            this.state.requestParams.subscriptionTierId != 5 &&
            /^(system administrator|account manager)/gi.test(
              this.props.roleName,
            ) &&
            /^(\/clients\/edit\/Client-Profile)/g.test(
              this.props.location.pathname,
            ) &&
            this.renderAccountDownloadConfig()}
          {this.state.requestParams.subscriptionTierId >= 3 &&
            this.state.requestParams.subscriptionTierId != 5 &&
            /^(system administrator|account manager|administrator|team member)/gi.test(
              this.props.roleName,
            ) &&
            /^(\/clients\/edit\/Business-Units\/detail)/g.test(
              this.props.location.pathname,
            ) /* || 
            /^(\/clients\/edit\/Client-Profile)/g.test(this.props.location.pathname)*/ &&
            /*
              <div style={{display: this.state.ifHiddenTopEdit ? 'none' : 'block', paddingLeft: '30%', paddingBottom: '29px'}}>
                <section style={{marginBottom: '29px'}}>
                  <span>Maximum Monthly Consumer Records <input disabled={/^(administrator|team member)/gi.test(this.props.roleName)} onBlur={(e) => this.handleConsumerRecords(e)} 
                    defaultValue={this.state.consumerRecords}
                    ref="consumer" type="text" style={{textAlign: 'center', border: /^(administrator|team member)/gi.test(this.props.roleName) ? 'none' : '1px solid #B1B0B0', width: '49px', height: '30px', marginLeft: /^(administrator|team member)/gi.test(this.props.roleName) ? '0' : '15px'}}/></span>
                </section>
                <section>
                  <span>Maximum Monthly Business Records <input disabled={/^(administrator|team member)/gi.test(this.props.roleName)} onBlur={(e) => this.handleBusinessRecords(e)} ref="business" type="text" style={{textAlign: 'center', border: /^(administrator|team member)/gi.test(this.props.roleName) ? 'none' : '1px solid #B1B0B0', width: '49px', height: '30px', marginLeft: /^(administrator|team member)/gi.test(this.props.roleName) ? '8px' : '22px'}}/></span>
                </section>
              </div>*/
            this.renderProfessionalConfig()}
          {/*for create client profile*/}
          {((this.state.requestParams.subscriptionTierId >= 3 &&
            this.state.requestParams.subscriptionTierId != 5) ||
            this.state.requestParams.subscriptionTierId === 1) &&
            /^(system administrator|account manager)/gi.test(
              this.props.roleName,
            ) &&
            /^(\/clients\/edit\/Client-Profile)/g.test(
              this.props.location.pathname,
            ) &&
            this.renderProfessionalConfig()}
          {/^(system administrator|account manager)/gi.test(
            this.props.roleName,
          ) &&
            /^(\/clients\/edit\/Client-Profile|\/clients\/edit\/Business-Units\/detail)/g.test(
              this.props.location.pathname,
            ) && (
              <div
                className="role clearfix"
                style={
                  this.state.ifHiddenTopEdit
                    ? {
                        lineHeight: "33px",
                        borderBottom: "1px solid #E8EBEF",
                        marginBottom: "0px",
                      }
                    : { lineHeight: "32px", marginBottom: "30px" }
                }
              >
                <p
                  style={{
                    color: "black",
                    fontSize: "16px",
                    float: "left",
                    width: "30%",
                    margin: 0,
                    fontWeight: "bolder",
                  }}
                >
                  Campaign Reporting <em style={{ color: "red" }}>*</em>
                </p>
                {this.state.ifHiddenTopEdit ? (
                  <div className="ml-10 pull-left">
                    {this.state.requestParams.campaignReportPreference &&
                      (this.state.requestParams.campaignReportPreference ===
                      "Detailed"
                        ? "Detailed Campaign Reporting"
                        : "Aggregate")}
                  </div>
                ) : (
                  <div
                    style={{ float: "left", minWidth: "400px", width: "68%" }}
                  >
                    <RadioButtonGroup
                      name="clientTier"
                      valueSelected={
                        this.state.requestParams.campaignReportPreference
                      }
                      onChange={(e, value) => {
                        e.preventDefault();
                        this.handledReportTypeChanged(value);
                      }}
                    >
                      <RadioButton
                        value={"Aggregated"}
                        label="Aggregate"
                        iconStyle={{
                          fill: "black",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                      <RadioButton
                        value={"Detailed"}
                        label="Detailed Campaign Reporting"
                        iconStyle={{
                          fill: "black",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </RadioButtonGroup>
                    <div
                      className="pt-10"
                      style={{
                        borderTop: "solid 1px #000000",
                        display:
                          this.state.requestParams.campaignReportPreference ===
                          "Detailed"
                            ? "block"
                            : "none",
                      }}
                    >
                      <Checkbox
                        label="Display Top Locations on Channel Reports"
                        checked={
                          this.state.requestParams.clientReportDetailSetting &&
                          this.state.requestParams.clientReportDetailSetting
                            .topLocationChannelReport
                        }
                        onCheck={(e, isInputChecked) =>
                          this.handleTopLocationReportCheck(e, isInputChecked)
                        }
                        iconStyle={styles.iconStyle}
                        labelStyle={styles.labelStyle}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}

          <div
            className="role clearfix"
            style={{
              lineHeight: "33px",
              borderBottom: this.state.ifHiddenTopEdit
                ? "1px solid #E8EBEF"
                : "",
              marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0",
            }}
          >
            <p
              style={{
                color: "black",
                marginTop: "7px",
                fontSize: "16px",
                float: "left",
                width: "30%",
                margin: 0,
                fontWeight: "bolder",
              }}
            >
              Industry Type<em style={{ color: "red" }}>*</em>
            </p>
            {this.state.ifHiddenTopEdit ? (
              <div className="pull-left pl-10" style={{ width: "70%" }}>
                {this.state.industry.name}
              </div>
            ) : (
              <CustomSelect
                placeholder="Select Industry Type"
                options={this.state.industryGroupObj}
                rootStyles={{
                  float: "left",
                  width: "68%",
                  border: "1px solid #B1B0B0",
                }}
                onChange={(value) => this.handleIndustryChange(value)}
                initValue={this.state.requestParams.industryId}
              />
            )}
          </div>
          {this.ifShowAssignTo() && (
            <div
              className="role clearfix"
              style={{
                lineHeight: "33px",
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "",
                marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0",
              }}
            >
              <p
                style={{
                  color: "black",
                  fontSize: "16px",
                  float: "left",
                  width: "30%",
                  margin: 0,
                  fontWeight: "bolder",
                }}
              >
                {/^\/clients\/edit\/Business-Units\/detail/g.test(
                  this.props.location.pathname,
                ) || /^administrator/gi.test(this.props.roleName)
                  ? "Assign Business Unit to"
                  : "Assign Client to"}
                {/^system administrator/gi.test(this.props.roleName) &&
                  !/^\/clients\/edit\/Business-Units\/detail/g.test(
                    this.props.location.pathname,
                  ) && <em style={{ color: "red" }}>*</em>}
              </p>
              {this.state.ifHiddenTopEdit ? (
                <div className="pull-left pl-10" style={{ width: "70%" }}>
                  {!isEmpty(this.state.accountManagers) &&
                  !isEmpty(this.state.accountManagers[0])
                    ? map(this.state.accountManagers, (data) => {
                        return data.firstName + " " + data.lastName;
                      }).join(", ")
                    : ""}{" "}
                </div>
              ) : (
                <Select
                  className="client-profile-timezone"
                  value={
                    this.state.requestParams &&
                    this.state.requestParams.accountManagerUserIds
                      ? this.state.requestParams.accountManagerUserIds
                      : this.state.accountManagers
                      ? map(this.state.accountManagers, "id")
                      : ""
                  }
                  clearable={false}
                  options={
                    this.props.editMode
                      ? /^\/clients\/edit\/Client-Profile/g.test(
                          this.props.location.pathname,
                        ) && /^system administrator/gi.test(this.props.roleName)
                        ? this.props.account_manager
                        : this.props.teamMember_options
                      : this.props.teamMember_options
                  }
                  multi
                  ifRequireField={true}
                  onChange={(value) => this.handleReassignTo(value)}
                />
              )}
            </div>
          )}
          {this.state.ifHiddenTopEdit && (
            <div className="btns">
              <button className="edit" onClick={() => this.handleEdit()}>
                EDIT
              </button>
              <button
                className="suspend"
                onClick={() => this.handleSuspendUser()}
              >
                {this.state.status === "Active"
                  ? "SUSPEND BUSINESS UNIT"
                  : "REACTIVATE BUSINESS UNIT"}
              </button>
            </div>
          )}
        </div>
        {!this.state.ifHiddenTopEdit && (
          <div className="profile-logo-wrapper">
            <div className="profile-logo profile-company-logo clearfix">
              <div className="clearfix">
                <div className="title clearfix">
                  <span id="profile-subtit">LOGO</span>
                </div>
                <div className="review">
                  <img
                    src={
                      localStorage.getItem("newLogoBase64") !== ""
                        ? localStorage.getItem("newLogoBase64")
                        : this.state.imgDataBase64
                    }
                    alt=""
                    style={{
                      display: this.state.ifHiddenLogoEdit
                        ? "inline-block"
                        : "none",
                    }}
                  />
                  <div
                    className="profile-edit-img"
                    style={{
                      display: this.state.ifHiddenLogoEdit ? "none" : "block",
                    }}
                  >
                    <section className="section">
                      Select a logo to upload
                    </section>
                    <Dropzone
                      onDrop={(files, accept, reject) =>
                        this.handleDrop(files, accept, reject)
                      }
                      style={{ width: "100%" }}
                      accept="image/jpeg, image/png, image/jpg, image/gif"
                      maxSize={1048576}
                      onDropRejected={() => this.onDropRejected()}
                      name="logo"
                    >
                      <p
                        style={{
                          textAlign: "center",
                          display: "inline-block",
                          width: "20%",
                          height: "20px",
                          fontSize: "12px",
                          border: "1px solid grey",
                          color: "black",
                          borderRadius: "6px",
                          lineHeight: "20px",
                          marginTop: "10px",
                        }}
                      >
                        Choose File
                      </p>
                      <i style={{ fontStyle: "normal", marginLeft: "6px" }}>
                        {(this.state.logoFileName !== undefined &&
                          this.state.logoFileName.name) ||
                          "No file chosen"}
                      </i>
                      <section className="spec">
                        (Only jpg, png, and gif file with maximum size of 1MB is
                        allowed)
                      </section>
                    </Dropzone>
                    <img src={this.state.newLogoBase64} alt="" />
                    <button
                      style={{ background: buttonBlueColor() }}
                      onClick={() => this.handleUploadLogo()}
                    >
                      UPLOAD LOGO
                    </button>
                  </div>
                </div>
              </div>
              <div className="error">
                {this.props.update_logo_msg || this.state.companyLogoErrorText}
              </div>
              <div className="profile-edit clearfix">
                <button
                  className="edit-button"
                  style={{
                    background: buttonBlueColor(),
                    display: this.state.ifHiddenLogoEdit ? "block" : "none",
                  }}
                  onClick={() => this.handleLogoEdit()}
                >
                  EDIT
                </button>
                <div
                  className="save-group clearfix"
                  style={{
                    display: this.state.ifHiddenLogoEdit ? "none" : "block",
                  }}
                >
                  <button
                    className={
                      this.state.ifHiddenTopEdit ? "save" : "add-margin save"
                    }
                    disabled={this.state.logoUploadSuccess ? "" : "disabled"}
                    style={{ background: buttonBlueColor() }}
                    onClick={() => this.handleUpdatelogo()}
                  >
                    SAVE
                  </button>
                  <button
                    className="cancel"
                    onClick={() => this.handleCancelLogoEdit()}
                  >
                    CANCEL
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/*for edit button*/}
        {!this.state.ifHiddenTopEdit && (
          <div
            className="btns"
            style={{ textAlign: "right", position: "relative" }}
          >
            <p style={{ position: "absolute", left: 0, color: "red" }}>
              {this.props.clientProfileUpdateError}
              {isEmptyAccIds &&
                /^system administrator/gi.test(this.props.roleName) &&
                !/^\/clients\/edit\/Business-Units\/detail/g.test(
                  this.props.location.pathname,
                ) &&
                "Please assign account manager"}
            </p>
            <button className="cancel" onClick={() => this.handleEdit()}>
              CANCEL
            </button>
            <button
              className="save"
              disabled={
                isEmptyAccIds &&
                /^system administrator/gi.test(this.props.roleName) &&
                !/^\/clients\/edit\/Business-Units\/detail/g.test(
                  this.props.location.pathname,
                )
              }
              onClick={() => {
                this.handleUpdate();
              }}
            >
              SAVE
            </button>
          </div>
        )}

        {/*success popover*/}
        {/*<Dialog*/}
        {/*modal={true}*/}
        {/*contentStyle={{ width: '40%' }}*/}
        {/*open={this.props.ifEditClientProfileSuccess}*/}
        {/*bodyStyle={{padding: '20px'}}*/}
        {/*>*/}
        {/*<div className="clearfix" style={{ position: 'relative' }}>*/}
        {/*<Clear*/}
        {/*style={{ position: 'absolute', right: '0em', cursor: 'pointer', top: '0em' }}*/}
        {/*onClick={() => this.closeDialog()}*/}
        {/*/>*/}
        {/*<h2 style={{ fontSize: '16px', fontWeight: 'bolder', color: 'black' }}>*/}
        {/*UPDATE CLIENT PROFILE*/}
        {/*</h2>*/}
        {/*{*/}
        {/*this.props.ifEditClientProfileSuccess && (*/}
        {/*<p style={{ textAlign: 'center', color: 'black', marginTop: '2em' }}>The profile was updated successfully.</p>*/}
        {/*)*/}
        {/*}*/}
        {/*<div className="form-btns clearfix" style={{ marginTop: '19px' }}>*/}
        {/*<a className="btn btn-link pull-right " id="userStatusA" style={{ marginLeft: '-1.3em', border: '1px solid #B1B0B0', fontWeight: 'bolder', padding: '7px 17px', borderRadius: '0', marginRight: '0.8em' }}*/}
        {/*onClick={(e) => this.handleClose()} >Close</a>*/}
        {/*</div>*/}
        {/*</div>*/}
        {/*</Dialog>*/}
        {/*suspend and reactivate user*/}
        <Dialog
          modal={true}
          contentStyle={{ width: "40%" }}
          open={this.props.ifEditClientProfileSuccess}
          bodyStyle={{ padding: "20px" }}
        >
          <div className="clearfix" style={{ position: "relative" }}>
            <Clear
              style={{
                position: "absolute",
                right: "0em",
                cursor: "pointer",
                top: "0em",
              }}
              onClick={() => this.handleClose()}
            />
            <h2
              style={{
                fontSize: "16px",
                fontWeight: "bolder",
                color: "black",
                marginTop: "0",
              }}
            >
              UPDATE {this.filterTitle()} PROFILE
              {/*UPDATE {/^(administrator|team member)/gi.test(this.props.roleName) ? 'BUSINESS UNIT' : 'CLIENT'} PROFILE*/}
            </h2>

            {this.props.ifEditClientProfileSuccess && (
              <p
                style={{
                  textAlign: "center",
                  color: "black",
                  marginTop: "1.2em",
                }}
              >
                The profile was updated successfully.
              </p>
            )}

            <div className="form-btns clearfix" style={{ marginTop: "19px" }}>
              <a
                className="btn btn-link pull-right "
                id="userStatusA"
                style={{
                  marginLeft: "-1.3em",
                  border: "1px solid #B1B0B0",
                  fontWeight: "bolder",
                  padding: "7px 17px",
                  borderRadius: "0",
                  marginRight: "0.8em",
                }}
                onClick={(e) => this.handleClose()}
              >
                Close
              </a>
            </div>
          </div>
        </Dialog>
        <Dialog modal={false} open={this.state.ifShowSuspend}>
          <p style={{ textAlign: "center", color: "black" }}>
            Are you sure you would like to{" "}
            {this.state.status === "Active" ? "suspend" : "reactivate"} this
            business unit?
          </p>
          <div className="btns" style={{ textAlign: "center" }}>
            <button
              style={suspendDialogStyle.cancel}
              onClick={() => this.handleCancelSuspend()}
            >
              CANCEL
            </button>
            <button
              style={suspendDialogStyle.suspend}
              onClick={() => this.suspendUser()}
            >
              {this.state.status === "Active" ? "SUSPEND" : "REACTIVATE"}{" "}
              BUSINESS UNIT
            </button>
          </div>
        </Dialog>
        {/*dialog*/}

        {/*for update logo*/}
        <Dialog
          actions={actions}
          modal={false}
          open={this.props.ifUpdateSuccess}
        >
          <p>Update logo successfully</p>
        </Dialog>
        <Dialog
          open={this.state.showDowngradeConfirm}
          contentStyle={{ width: "435px", padding: "20px" }}
        >
          <p style={{ fontWeight: "bold", color: "#000" }}>
            Changing the subscription tier to Basic will stop file exports,
            limit some reporting views, and limit the number of segments that
            can be saved.
          </p>
          <FullRow className="text-center no-padding-bottom no-margin-bottom">
            <a
              className="btn btn-default btn-aa-info"
              onClick={(e) => {
                e.preventDefault();
                this.setState({ showDowngradeConfirm: false });
              }}
            >
              Cancel
            </a>
            <a
              className="btn btn-default btn-aa-warning ml-20"
              onClick={this.saveDowngradeClient.bind(this)}
            >
              Continue
            </a>
          </FullRow>
        </Dialog>
      </div>
    );
  }
}

export default BusinessUnitsDetail;



// WEBPACK FOOTER //
// ./src/components/Clients/EditClientProfile/BusinessUnitsDetail.jsx